import type {
    IConfig,
    IConfiguration,
    ITelemetryPlugin,
} from "@microsoft/applicationinsights-web";

/**
 * Builds the ApplicationInsights config for appInsights.ts. `disablePageUnloadEvents`: Chrome's
 * default unload deprecation policy (this repo sets no Permissions-Policy header) reports a
 * violation for every `unload` listener, so the SDK is asked not to register one while
 * beforeunload, pagehide and visibilitychange keep flushing telemetry (#295). The exclusion is
 * best-effort — the SDK re-registers `unload` only if both beforeunload and pagehide fail to
 * attach (applicationinsights-core-js.js:6921-6926). `instrumentationKey` is typed `string`
 * because REQUIRED_ENV_KEYS in vite.config.ts fails the build when the env var is missing.
 */
export const buildAppInsightsConfig = (
    instrumentationKey: string,
    extensions: ITelemetryPlugin[],
): IConfiguration & IConfig => ({
    instrumentationKey,
    extensions,
    disablePageUnloadEvents: ["unload"],
});
